import React from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, Link } from '@chakra-ui/react';

export const Shotgun = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        Golden Gun Club offers a wide range of Trap, Skeet and 5 Stand shooting for the occasional clay shooter just coming out for fun, the bird hunter getting ready for the season, and the competitive Trap or Skeet shooter. We offer weekly Trap and Skeet leagues in the spring, summer and fall seasons. For more info on leagues, follow the links below:
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><Link href="/matches-competition/trap-league/trap-league-info" color="blue.500">Trap League</Link></ListItem>
        <ListItem><Link href="/matches-competition/five-stand-league-info" color="blue.500">Skeet/Five-Stand League</Link></ListItem>
      </UnorderedList>

      <Text mb={4} color="black">
        Check out <Link href="/about-us/calendar" color="blue.500">our monthly calendar</Link> for event dates.
      </Text>

      <Text mb={4} color="black">
        The Club has two dedicated Trap fields, six combination Skeet and Trap fields and a 5 Stand field sprawling across a 160-acre facility. The Club is complete with kitchen for lunch or quick snack. We serve barbecue fare including sizzling burgers and brats, all at very reasonable prices during large shoots and busy weekends.
      </Text>

      <Text mb={4} color="black">
        Our Trap, Skeet and 5 Stand can be booked by corporations and organizations for group activities. For information on how to organize your "clay shooting" event, call the clubhouse at 303-366-6970 and ask for Alex Reyenga.
      </Text>

      <Text mb={4} color="black">
        We are currently accepting new Shotgun Memberships at a cost of $120 per year. The Rifle and Pistol Ranges are available only to rifle/pistol members of the Club.
      </Text>

      <Text mb={6} color="black" fontWeight="bold">
        Shotgun Targets for Sale!
      </Text>
      <Text mb={2} color="black">
        Trap & Skeet - $7 members, $9 non-members
      </Text>
      <Text mb={6} color="black">
        5 Stand - $8 members, $11 non-members
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Shooting Instruction</Heading>
      <Text mb={6} color="black">
        Golden Gun Club does not offer instruction through the Club at this time. If you need information on instruction, please speak with the Club Instructor and he can relay you to an appropriate expert.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Shotgun Range Rules</Heading>
      <UnorderedList spacing={2} ml={6} mb={6}>
        <ListItem>All persons must wear protective shooting glasses and ear protection at all times when on any shooting course, ie. Trap, Skeet, Sporting Clays, or Patterning Board</ListItem>
        <ListItem>Largest shotgun ammunition allowed is 12ga. 2 3/4 in. length and 1 1/8 oz of shot, unless by special arrangement. Target Loads Only! 7 1/2, 8, 8 1/2 or 9 shot only.</ListItem>
        <ListItem>While waiting your turn to shoot, be certain your position is safely behind the shooter, clear of his field of vision.</ListItem>
        <ListItem>The only time a shotgun will be loaded is when the shooter is actually on station and ready for his turn to shoot.</ListItem>
        <ListItem>Practice swings from behind any station are not allowed.</ListItem>
        <ListItem>At no time will a shooter load more than 2 shells in a shotgun</ListItem>
        <ListItem>Before leaving the station, shooters will ensure that the gun is unloaded and the action is open.</ListItem>
        <ListItem>No alcoholic beverages are allowed on club property.</ListItem>
        <ListItem>Never handle another shooters gun without permission.</ListItem>
        <ListItem>It is strictly forbidden to shoot any bird or animal on any shooting course or field at Golden Gun Club.</ListItem>
        <ListItem>If you have an ATV, such as a Mule, Gator, 4 Wheeler, or Golf Cart, we ask that you use extreme caution and respect fellow shooters who are walking and keep your speed moderate.</ListItem>
        <ListItem>All pets are to be on a leash or an electric collar and under owner control at all times.</ListItem>
        <ListItem>Should you experience an ammunition malfunction or gun malfunction, keep the muzzle pointed down range until the firearm is rendered safe.</ListItem>
        <ListItem>If you have a problem with any employee of Golden Gun Club, we respectfully ask that you bring it to the attention of the management, and let us handle it.</ListItem>
        <ListItem>Illegal drugs are not allowed or permitted on Golden Gun Club property at any time.</ListItem>
      </UnorderedList>

      <Heading as="h3" size="md" mb={3} color="black">ATA Trap Shoots</Heading>
      <Text mb={4} color="black">
        Sat. & Sun. 4/6 &7/24 Annual Silver Bar Shoot<br/>
        Sat. 5/4/24 May Days<br/>
        Sat. 7/27/24 Patriot Shoot<br/>
        Sat. & Sun. 10/5 & 6/24 4th Annual Rocky Mountain Handicap
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">NSSA Skeet Shoots</Heading>
      <Text mb={4} color="black">
        Sun. 4/14/24 Early Bird Clays<br/>
        Sat. & Sun. 5/18 & 5/19/24 Birds of May<br/>
        Sun. 6/9/24 Summer Clays<br/>
        Sun. 7/14/24 Heating Up Clays<br/>
        Sun. 8/11/24 Last Chance<br/>
        Fri, Sat & Sun 9/13,14 & 15/24 CSSA State Shoot
      </Text>
    </Box>
  );
};